exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-booking-ivr-panel{background-color:#fff;border-radius:6px;padding:16px;position:relative}@media only screen and (max-width: 768px){.share-booking-ivr-panel{padding:16px;border-radius:0px}}", ""]);

// exports
